import { ArrowRight, ArrowDownRight } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/9cc71183-e08c-4a6f-a9e5-3cc8fb0af69f/images/279844d47315b3eec08f47120e2753098fdee4719366598d078347d56ef4ada0.png";

export default function Hero() {
  const scrollTo = (id) => () => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28 bg-[#FAFAFA] overflow-hidden"
    >
      {/* Top meta bar */}
      <div className="px-6 md:px-12 lg:px-16 max-w-[1440px] mx-auto">
        <div className="flex items-center justify-between border-b border-[#E5E5E5] pb-5 mb-12 text-[#525252]">
          <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em]">
            <span className="w-2 h-2 bg-[#0047FF] rounded-full animate-pulse" />
            Aceptando nuevos proyectos
          </div>
          <div className="hidden sm:block font-mono text-[11px] uppercase tracking-[0.18em]">
            Software · Mobile · IA
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8 reveal reveal-d-1">
            <span className="eyebrow">[ 01 ] Agencia tecnológica B2B</span>
            <h1 className="display-1 mt-6 max-w-[18ch]">
              Software, Apps & <span className="text-[#0047FF]">IA</span> que
              transforman tu empresa.
            </h1>
            <p className="mt-8 max-w-xl text-[#525252] text-base md:text-lg leading-relaxed">
              Impulsamos a empresas líderes en México y Latinoamérica con tecnología
              de vanguardia y metodologías ágiles. Resultados medibles, código de
              excelencia.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <button
                data-testid="hero-cta-primary"
                onClick={scrollTo("#contacto")}
                className="btn-primary"
              >
                Inicia tu proyecto <ArrowRight size={16} />
              </button>
              <button
                data-testid="hero-cta-secondary"
                onClick={scrollTo("#servicios")}
                className="btn-secondary"
              >
                Conoce nuestros servicios <ArrowDownRight size={16} />
              </button>
            </div>
          </div>

          <div className="lg:col-span-4 reveal reveal-d-3">
            <div className="grid grid-cols-2 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
              {[
                { k: "+12", v: "Años entregando" },
                { k: "98%", v: "Retención de clientes" },
                { k: "+80", v: "Proyectos lanzados" },
                { k: "24h", v: "Tiempo de respuesta" },
              ].map((s) => (
                <div key={s.v} className="bg-white p-5 md:p-6">
                  <div className="font-display text-3xl md:text-4xl font-black tracking-tight">
                    {s.k}
                  </div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#525252] mt-1">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Hero image band */}
        <div className="mt-16 md:mt-20 reveal reveal-d-4 zoom-wrap relative overflow-hidden border border-[#E5E5E5]">
          <img
            src={HERO_IMG}
            alt="Composición abstracta representando IA y desarrollo de software"
            className="zoom-img w-full h-[320px] md:h-[460px] object-cover"
            data-testid="hero-image"
          />
          <div className="absolute bottom-4 left-4 md:bottom-6 md:left-6 bg-white px-4 py-2 font-mono text-[10px] uppercase tracking-[0.18em] text-[#171717] border border-[#E5E5E5]">
            Inteligencia Artificial · Software · Mobile
          </div>
        </div>
      </div>
    </section>
  );
}
